import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import { ReactComponent as LogoSvg } from '../../assets/icons/logo.svg';

function Logo({ rootStyle }) {

  return (
    <Row
      align="middle"
      justify="center"
      gutter={12}
      style={{ width: '100%' }}
      wrap={false}
    >
      <Col>
        <img
          alt="Alemhealth"
          src={`${window.location.origin  }/alem_health_logo.png`}
          style={{
            height: 25,
            width: 120,
            objectFit: 'contain',
          }}
        />
      </Col>
      {/* <Col span={12}>
        <strong style={{ fontSize: 20 }}>SafelyWith</strong>
      </Col> */}
    </Row>
  );
}

Logo.defaultProps = {
  rootStyle: {},
};

const { shape } = PropTypes;

Logo.propTypes = {
  rootStyle: shape({}),
};

export default Logo;
